import { createAsyncThunk } from "@reduxjs/toolkit";
import { CHARGING_NETWORKS } from "../../../API/UserApi";
import axios from "axios";
import apiHeader from "../../../Components/ApiHeader";

export const addNetworksAPI: any = createAsyncThunk(
  "addNetworks",
  async ({ formData, method, id }: any, { rejectWithValue }: any) => {
    const token: any = localStorage.getItem("token");
    const commonHead = apiHeader(token);
    try {
      const res = await axios({
        method: method,
        url: !!id ? CHARGING_NETWORKS + id : CHARGING_NETWORKS,
        data: formData,
        headers: commonHead,
      });

      ;
      return res;
    } catch (error: any) {
      console.log(error, "errorrr");
      // if (error instanceof Error) {
      return rejectWithValue({
        error: { code: error.response.status, message: error.message },
      });
      // }
    }
  }
);
